// extracted by mini-css-extract-plugin
module.exports = {"container":"_1f6rAzH7BRVQGkeL6TSY1w","officeGroup":"_3TorgfH5D-XkT1XoHyoOaF"};